import type { IconSvgObject } from './types';

const Joystick05Icon: IconSvgObject = [
  ["path", { d: "M15.5 5.5C15.5 7.433 13.933 9 12 9C10.067 9 8.5 7.433 8.5 5.5C8.5 3.567 10.067 2 12 2C13.933 2 15.5 3.567 15.5 5.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 22H5C4.44772 22 4 21.5523 4 21V18.6667C4 18.2339 4.14036 17.8129 4.4 17.4667L6.4 14.8C6.77771 14.2964 7.37049 14 8 14H16C16.6295 14 17.2223 14.2964 17.6 14.8L19.6 17.4667C19.8596 17.8129 20 18.2339 20 18.6667V21C20 21.5523 19.5523 22 19 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 19H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 9V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Joystick05Icon;
